
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"9","cy":"9","r":"6","stroke":"#fff","stroke-width":"1.5"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9 7.667A.833.833 0 109 6a.833.833 0 000 1.667zM9.75 9a.75.75 0 00-1.5 0v2.333a.75.75 0 001.5 0V9z","fill":"#fff"}})])
          )
        }
      }
    